import {USER_ROLES} from "@/constants";

export default class DisabilityPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        //
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  disability
     * @return {mixed}
     */
    view(user, disability)
    {
        //
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        //
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  disability
     * @return {mixed}
     */
    update(user, disability)
    {
        //
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  disability
     * @return {mixed}
     */
    restore(user, disability)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  disability
     * @return {mixed}
     */
    delete(user, disability)
    {
        //
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  disability
     * @return {mixed}
     */
    forceDelete(user, disability)
    {
        //
    }

    /**
     * User can revoke the drop_date
     * @param user
     * @returns {boolean}
     */
    revoke(user){
        return USER_ROLES.ADMIN === user.role;
    }
}
